/**
 *
 * @param trackPosition - Track position value
 * @returns  If the track is type of unmatched flag
 */
export function isUnmatchedFlag(trackPosition: number) {
  return trackPosition === -1 ? true : false;
}
